import $ from "jquery";
import '../../global/js/cms.js';
import 'bootstrap/js/dist/tooltip';
import * as bootstrap from "bootstrap";
import '@selectize/selectize';


$(function () {
    $(function () {
        $("select").selectize({});
    });

    $('.hamburger').click(() => {
        $('.menu').toggle();
    });
})


let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
        html: true
    })
})
